export default __webpack_public_path__ + "static/media/Metaland.98fe193c.png";